import React from 'react'
import styled from 'styled-components'
import MainBatchFailList from './mainBatchFailList'
import MainPriceCheckList from './mainPriceCheckList'
import MainBoard from './mainBoard'

const MainContainer = styled.div`
  flex: 1;
  border: 1px solid;
  height: 100%;
  margin: 0.5rem;
  padding: 1rem;
  border-radius: 0.5rem;
`
const Main: React.FC = () => {
  return (
    <>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          height: '30rem',
        }}
      >
        <MainContainer>
          <MainBatchFailList />
        </MainContainer>
        <MainContainer>
          <MainPriceCheckList />
        </MainContainer>
        <MainContainer>
          <MainBoard />
        </MainContainer>
      </div>
    </>
  )
}

const MainWrapper = styled.div`
  display: flex;
  justifycontent: space-between;
`

export default Main
